import { DefaultSequenceConditions, SequenceInterface, SequenceSubType } from "@swivl-mono/types";
import _ from "lodash";

export class SequenceHelper {
  static isAnySequenceSubType(type: SequenceSubType, sequences: SequenceInterface[]): boolean {
    return sequences.some((s) => s.subType === type);
  }
  static isAnySequenceCondistionEqualTo(conditionKey: string, conditionValue: string, sequences: SequenceInterface[]): boolean {
    return sequences.some((s) => {
      const conditions: any = s.conditions;
      return conditions[conditionKey] && String(conditions[conditionKey]) === String(conditionValue);
    });
  }

  // static isSequenceSubType(type: SequenceSubType, sequence: SequenceInterface): boolean {
  //   const arrayOfConditions = Object.values(SequenceSubType);
  //   for (let index = 0; index < arrayOfConditions.length; index++) {
  //     const t = arrayOfConditions[index];
  //     if (t !== SequenceSubType.CUSTOM && t === type && _.isEqual(DefaultSequenceConditions[t as SequenceSubType], sequence.conditions)) {
  //       return true;
  //     }
  //   }

  //   if (type === SequenceSubType.CUSTOM) {
  //     return true;
  //   }

  //   return false;
  // }
}
